<template>
  <div
    class="br-subleft overflow-y-auto"
    :data-min="status"
  >
    <!--<div
      class="left-side-switch"
      onclick="sideChangeStatus();"
    >
      <i
        class="fa"
        :class="status ? 'fa-angle-double-right':'fa-angle-double-left'"
      ></i>
    </div>-->
    <h6 class="tx-uppercase tx-10 tx-mont tx-spacing-1 mg-t-10 pd-x-10 tx-white-7">{{$t('other.条件筛选')}}</h6>
    <div class="mg-t-10 pd-x-10 mg-b-40">
      <div class="datepicker-group mg-b-15">
        <div class="input-group">
          <span class="input-group-addon"><i class="icon ion-calendar tx-16 lh-0 op-6"></i></span>
          <input
            v-model="dateFrom"
            data-id="datepicker-from"
            type="text"
            class="form-control-dark form-control fc-datepicker"
            :placeholder="$t('other.流水起始日期')"
          >
        </div>
        <div class="input-group">
          <span class="input-group-addon"><i class="icon ion-calendar tx-16 lh-0 op-6"></i></span>
          <input
            v-model="dateTo"
            data-id="datepicker-to"
            type="text"
            class="form-control form-control-dark fc-datepicker"
            :placeholder="$t('other.流水截止日期')"
          >
        </div>
      </div>
      <div class="form-group mg-b-15">
        <select class="form-control form-control-dark " v-model="kStatus"  @change="filtrate">
          <option value="">{{$t('other.选择流水状态')}}</option>
          <option
            v-for="(s,k) in $dict.costFlowStatus"
            :key="k"
            :value="k"
          >{{$t(s)}}</option>
        </select>
      </div>
      <button
        class="btn btn-primary btn-block tx-uppercase tx-11 tx-spacing-2 tx-medium"
        @click="filtrate"
      >{{$t('other.筛 选')}}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["status", 'keyDateFrom', 'keyDateTo', 'keyStatus'],
  data() {
    return {
      dateFrom: "",
      dateTo: "",
      kStatus: '',
    };
  },
  watch: {
    keyDateFrom(){
      this.dateFrom = this.keyDateFrom;
    },
    keyDateTo(){
      this.dateTo = this.keyDateTo;
    },
    keyStatus(){
      this.kStatus = this.keyStatus;
    },
  },
  methods: {
    filtrate() {
      this.$emit('filtrate', this.dateFrom, this.dateTo, this.kStatus);
    },
    datepickerSelect() {
      let vm = this;
      $(".br-subleft [data-id=datepicker-from]").each(function() {
        $(this).datepicker({
          numberOfMonths: 1, //$t('other.显示月的数量')
          dateFormat: "yy-mm-dd", //$t('other.日期格式化')
          onClose: function(selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-to]"))
              .datepicker("option", "minDate", selectedDate);
          },
          onSelect: function(selectedDate) {
            vm.dateFrom = selectedDate;
          }
        });
      });
      $(".br-subleft [data-id=datepicker-to]").each(function() {
        $(this).datepicker({
          numberOfMonths: 1, //$t('other.显示月的数量')
          dateFormat: "yy-mm-dd", //$t('other.日期格式化')
          onClose: function(selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-from]"))
              .datepicker("option", "maxDate", selectedDate);
          },
          onSelect: function(selectedDate) {
            vm.dateTo = selectedDate;
          }
        });
      });
    },
  },
  mounted() {
    this.datepickerSelect();
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
  updated() {
    this.datepickerSelect();
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  }
};
</script>